import Icon from '../Components/Icon';
import PageHeader from '../Components/PageHeader';
import { contact } from '../data/site';

const methods = [
  { icon: 'phone', label: 'Mobile', value: contact.phone, link: contact.phoneLink },
  { icon: 'mail', label: 'Email', value: contact.email, link: contact.emailLink },
  { icon: 'pin', label: 'Address', value: contact.address, link: contact.mapLink, external: true },
];

const Contact = () => (
  <>
    <PageHeader eyebrow="Contact" title="Connect with us">
      Call, email or visit our Lucknow office.
    </PageHeader>

    <section className="section">
      <div className="container card-grid card-grid--three">
        {methods.map((method) => (
          <a
            key={method.label}
            className="card card--link"
            href={method.link}
            {...(method.external ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            <span className="card__icon"><Icon name={method.icon} /></span>
            <h2>{method.label}</h2>
            <p>{method.value}</p>
          </a>
        ))}
      </div>
    </section>
  </>
);

export default Contact;
